var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, TextField } from '@mui/material';
import { SectionTitle } from '../components/StyledComponent';
import AppConfig from '../AppConfig';
import ReCAPTCHA from 'react-google-recaptcha';
import { useContext, useRef, useState } from 'react';
import { sendSupportMessage } from '../rest/BackendApi';
import UserContext from '../UserContext';
import Divider from '@mui/material/Divider';
export default function SupportPage() {
    const userContext = useContext(UserContext);
    const user = userContext === null || userContext === void 0 ? void 0 : userContext.user;
    const recaptcha = useRef(null);
    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState(false);
    const [emailFrom, setEmailFrom] = useState('');
    const [emailFromError, setEmailFromError] = useState(false);
    const [captchaError, setCaptchaError] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const handleSubmit = (event) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        event.preventDefault();
        setMessageError(false);
        setCaptchaError(false);
        setEmailFromError(false);
        if (message == '') {
            setMessageError(true);
        }
        else if (user == null && emailFrom == '') {
            setEmailFromError(true);
        }
        else {
            let captcha = (_a = recaptcha.current) === null || _a === void 0 ? void 0 : _a.getValue();
            if (captcha) {
                yield sendSupportMessage(message, captcha, user ? undefined : emailFrom);
                setConfirmation(true);
                setMessage('');
            }
            else {
                setCaptchaError(true);
            }
        }
    });
    return (_jsx("div", { children: _jsxs(Stack, { alignItems: "center", gap: 2, children: [_jsx(SectionTitle, { children: "Support/Help" }), _jsx(Divider, { flexItem: true, textAlign: "center", variant: "middle", children: _jsx("b", { children: "Existing resources" }) }), _jsx("a", { target: "_blank", href: "https://basready.com.au/knowledge-base/", children: "Knowledge base" }), _jsx("a", { target: "_blank", href: "https://basready.com.au/FAQ/", children: "FAQ" }), _jsx(Divider, { flexItem: true, textAlign: "center", variant: "middle", children: _jsx("b", { children: "Contact Us" }) }), confirmation ? (_jsx("div", { children: "Message sent. Thanks for your feedback." })) : (_jsxs("div", { children: [_jsx("div", { style: { marginBottom: 20, marginTop: 10 }, children: "Please send us a message and we will try to get back to you as soon as possible." }), _jsxs("form", { onSubmit: handleSubmit, children: [user ? (_jsx(TextField, { disabled: true, label: "From", variant: "outlined", value: user.email, fullWidth: true, sx: { mb: 3 } })) : (_jsx(TextField, { multiline: true, value: emailFrom, error: emailFromError, required: true, onChange: e => setEmailFrom(e.target.value), label: "From (Email) ", type: "email", fullWidth: true, variant: "outlined", sx: { mb: 3 } })), _jsx(TextField, { multiline: true, value: message, error: messageError, required: true, onChange: e => setMessage(e.target.value), label: "Message", rows: 8, type: "text", fullWidth: true, variant: "outlined", sx: { mb: 3 } }), captchaError && _jsx("div", { children: "Invalid captcha" }), _jsx(ReCAPTCHA, { ref: recaptcha, sitekey: AppConfig.recaptchaSiteKey }), _jsx(Button, { sx: { mt: 3, mb: 3 }, variant: "outlined", type: "submit", children: "Send message" })] })] }))] }) }));
}
